import { createContext } from 'react';

// Lightweight context carrying only the selected property id and dispatch.
// Row components (FarmRow, FieldRow, CropZoneRow) read from this instead of
// the monolithic global Store, so memo() actually prevents re-renders when
// unrelated global state changes.
const SelectedPropertyContext = createContext({
  selectedPropertyId: null,
  updateCropName: null,
  dispatch: () => {}
});

export default SelectedPropertyContext;
